
<div id="page-container" class="main-content-boxed page-header-fixed">
 
    <div id="page-header">
      <app-navbar></app-navbar>
    </div>

    <div id="main-container">
      <router-outlet></router-outlet>
    </div>

    <div id="page-footer">
      <app-footer></app-footer>
    </div>

</div>
